export default __webpack_public_path__ + "static/media/order.06482898.jpg";